export interface PostPracticeState {
    postReport: any;
    helpList: any;
    postResults: any;
    allPostReports: any,
    loading: boolean;
}

export enum PostPracticeActionType {
    START_REQUEST = "START_REQUEST",
    POST_REPORT_LOADED = "POST_REPORT_LOADED",
    ALL_POST_REPORTS_LOADED = "ALL_POST_REPORTS_LOADED",
    HELP_LIST_LOADED = "HELP_LIST_LOADED",
    POST_RESULTS_LOADED = "POST_RESULTS_LOADED",
    FINISH_REQUEST = "FINISH_REQUEST",
}